// src/api/dashboardApi.js
import api from "./axios";

export const getDashboardMetrics = async (zoneName) => {
  const response = await api.get("/analytics/dashboard/metrics/", {
    params: zoneName ? { zone_name: zoneName } : {},
  });
  return response.data;
};
 


export const getProjectDrilldown = async (id) => {
  if (!id) throw new Error("Project ID is required");
  
  const response = await api.get(`/analytics/dashboard/drilldown/?id=${id}`);
  return response.data;
};
/** NEW: Download Excel Report */
export const exportDashboardReport = async () => {
  const response = await api.get("/analytics/dashboard/export-excel/", {
    responseType: "blob",        // Important for file download
  });

  // Create downloadable link
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `Dashboard_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
export const getMilestoneDelays = async (zoneName) => {
  const response = await api.get("/analytics/api/dashboard/milestones/", {
    params: zoneName ? { zone_name: zoneName } : {},
  });
  return response.data; // { count, results: [...] }
};